import { styled } from '@mui/material/styles';

/** Light panel with an orange left border, used for notes and highlights. */
const Callout = styled('div')(({ theme }) => ({
  background: theme.palette.staticPages.bg.callout,
  border: `1px solid ${theme.palette.staticPages.border.callout}`,
  borderLeft: `4px solid ${theme.palette.staticPages.orange}`,
  borderRadius: theme.shape.borderRadius * 3,
  padding: theme.spacing(2.5),
  [theme.breakpoints.up('md')]: { padding: theme.spacing(3) },
}));

export default Callout;
